import { render } from "./CoachFilter.vue?vue&type=template&id=5f5d50f2&scoped=true"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import "./CoachFilter.vue?vue&type=style&index=0&id=5f5d50f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f5d50f2"

export default script